import React from "react";
import { Loader2 } from "lucide-react";

export default function QuickLoader() {
  return (
    <div className="flex flex-col items-center justify-center py-24 gap-3">
      <div className="w-12 h-12 rounded-2xl bg-[#7B2D3F]/10 flex items-center justify-center">
        <Loader2 className="w-5 h-5 animate-spin text-[#7B2D3F]" />
      </div>
      <p className="text-xs text-gray-400 font-medium">Carregant...</p>
    </div>
  );
}